/**
 * Where focus goes when the Transfers drawer closes (final UI/UX batch C1, reviews R7 / N18): back to the element that
 * opened it (the chip, the Home card's Transfers, the toast action). The drawer has no Radix trigger, so without this
 * Radix focused nothing and focus fell to <body>. When the opener is gone — the Connections dialog closed with its
 * card, or Clear finished removed the chip — the chip is next, then the active workspace tab. Another dialog open by
 * then (Propagate again… closes the drawer and opens its dialog) keeps its own focus.
 */
import { useTransfersPanelStore } from '../store/transfersPanelStore';

const usable = (element: HTMLElement | null | undefined): element is HTMLElement =>
  !!element && element.isConnected && !element.closest('[inert],[aria-hidden="true"]') && !(element as HTMLButtonElement).disabled;

export function restoreTransfersPanelFocus(): void {
  const { opener } = useTransfersPanelStore.getState();
  useTransfersPanelStore.setState({ opener: null });
  if (document.querySelector('[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]')) return;
  const candidates = [
    opener,
    document.querySelector<HTMLElement>('[data-testid="transfers-chip"]'),
    document.querySelector<HTMLElement>('[role="tab"][aria-selected="true"]'),
  ];
  for (const candidate of candidates) {
    if (!usable(candidate)) continue;
    candidate.focus();
    if (document.activeElement === candidate) return;
  }
}
